<div *ngIf="data.withX==true" mat-dialog-actions align="end">
  <button mat-icon-button  (click)="onNoClick()">
      <mat-icon>close</mat-icon>
  </button>
  <mat-divider></mat-divider>
</div>
<div mat-dialog-content style="text-align: center; height:100%">

<h6>{{data.title}}</h6>

<div *ngIf = "!_isVideo; else Video">
  <span>{{data.content}}</span>
</div>
<ng-template #Video>
  
  <youtube-player    #player
  videoId="FuAgzCk1XR8" 

  (ready)="onReady($event)"
  suggestedQuality="highres" 
 width="100%"
  height="90%"
  >
</youtube-player>
 <!-- [height]="250" 
  [width]="500" 
  [startSeconds]="0"
  [endSeconds]="8" -->
</ng-template>
</div>

<div mat-dialog-actions align="end">


  <button mat-button (click)="onNoClick()">Fechar</button>

</div>